export default __webpack_public_path__ + "static/latitude-mastercard-a7b2bbb4ba2c3da5669ff3f8809a2ff8.png";